import apiFetch from '../apiFetch'

export default function (organizedUnitId, dossierId, token) {
  return apiFetch({ endPoint: `processingAgency/${dossierId}?organizedUnitId=${organizedUnitId}`, method: 'GET', token: token })
}
